import styled from 'styled-components'

import Colors from 'utils/Colors'

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 0 2rem;
  margin-bottom: 2rem;
  
  .mobile_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100vw;
    height: auto;
    min-height: calc(100vh - 64px);
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 2rem;
  }

  .content {
    padding: 0 2rem;
  }

  .full_width {
    width: 100%;

    &:not(:first-child) {
      margin: 0 2rem;
    }
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1.5rem 2rem;
    background-color: ${Colors.loginPrimaryColor};
    width: 100%;
    margin-bottom: 1.5rem;
    @media screen and (max-width: 450px) {
      justify-content: center;
    }
    
    & span, & a {
      text-align: left
      @media screen and (max-width: 450px) {
        text-align: center;
      }
    
    }

    &__logo {
      width: 120px;
      height: auto;
      screen and (max-width: 450px) {
        width: 40%;
      }
    }
  }

  .main {
    .not_supported {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      font-weight: 700;
      text-align: center;
      margin-top: 4rem;
      color: ${(props) => props.theme.palette.gray[600]};

      svg {
        color: ${(props) => props.theme.palette.gray[300]};
        width: 10rem;
        height: 10rem;
        margin-bottom: 3rem;
      }

      small {
        margin-top: 2rem;
        font-size: 1.6rem;
        font-weight: 600;
        color: ${(props) => props.theme.palette.gray[500]};
      }
    }

    .desktop_warning {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h3 {
        font-size: 2.6rem;
        text-transform: uppercase;
        color: ${(props) => props.theme.palette.primary};
        margin-bottom: 2rem;
      }

      svg {
        color: ${(props) => props.theme.palette.gray[300]};
        width: 10rem;
        height: 10rem;
        margin-bottom: 3rem;
      }

      p {
        font-size: 1.6rem;
        text-align: center;
        color: ${(props) => props.theme.palette.gray[600]};
        margin-bottom: 3rem;
      }
    }
  }

  .tip {
    border-collapse: collapse;
    font-size: 1.4rem;
    margin-top: 2rem;
    margin-bottom: 1rem;

    tbody {
      tr {
        &:not(:last-child) {
          border-bottom: 1px solid ${(props) => props.theme.palette.gray[200]};
        }

        td {
          padding: 1.5rem 0;

          svg {
            width: 2.4rem;
            height: 2.4rem;
            margin-right: 1rem;
            color: #fcba03;
          }
        }
      }
    }
  }
`
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3rem;

  & > button:not(:first-child) {
    margin-left: 3rem;
  }
`
